import netlifyIdentity from 'netlify-identity-widget';

export default netlifyIdentity;
